// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"10": "home/site-preview/page","13": "page","14": "site-preview/$","15": "site-preview/page","16": "web-syndication/(permaLink)/page","17": "web-syndication/layout","18": "web-syndication/page","7": "$","8": "async-main","9": "home/page",}[chunkId] || chunkId) + ".js"
}